import { Injectable } from '@angular/core';
import { AddressService } from "../address.service";
import { FormControlBase } from "../../dynamic-form/form-control-base";
import { TextboxControl } from "../../dynamic-form/textbox-control";
import { DropdownControl } from "../../dynamic-form/dropdown-control";
import { DatepickerControl } from "../../dynamic-form/datepicker-control";
import { CheckboxControl } from "../../dynamic-form/checkbox-control";
import { TextareaControl } from '../../dynamic-form/textarea-control';

@Injectable()
export class CustomerManagementFieldService {

    constructor(
        private addressService: AddressService
    ) {  }

    public getFields(): Array<FormControlBase<any>> {
        let fields = new Array<FormControlBase<any>>();

        let firstNameField = new TextboxControl();
        firstNameField.key = 'firstName';
        firstNameField.label = 'First Name';
        firstNameField.placeHolder = 'Enter first name';
        firstNameField.order = 1;
        firstNameField.validNoNumber = true;
        firstNameField.preventKeys = '[a-zA-Z]';
        fields.push(firstNameField);

        let surnameField = new TextboxControl();
        surnameField.key = 'surname';
        surnameField.label = 'Surname';
        surnameField.placeHolder = 'Enter surname';
        surnameField.order = 2;
        surnameField.preventKeys = '[a-zA-Z]';
        fields.push(surnameField);

        let genderField = new DropdownControl();
        genderField.key = 'gender';
        genderField.label = 'Gender';
        genderField.order = 3;
        genderField.options = [
            { key: 'M', value: 'Male' },
            { key: 'F', value: 'Female' }
        ];
        fields.push(genderField);

        let address1Field = new TextboxControl();
        address1Field.key = 'address1';
        address1Field.label = 'Address';
        address1Field.placeHolder = 'Enter address';
        address1Field.order = 4;
        fields.push(address1Field);

        let address2Field = new TextboxControl();
        address2Field.key = 'address2';
        address2Field.label = '';
        address2Field.placeHolder = 'Enter address';
        address2Field.order = 5;
        fields.push(address2Field);

        let cityField = new TextboxControl();
        cityField.key = 'city';
        cityField.label = 'City';
        cityField.placeHolder = 'Enter city'
        cityField.order = 6;
        cityField.preventKeys = '\\w';
        fields.push(cityField);

        let provinceField = new DropdownControl();
        provinceField.key = 'province';
        provinceField.label = 'Province';
        provinceField.order = 6.5;
        provinceField.options = [
            { key: '1', value: 'Unknown' },
            { key: '2', value: 'Eastern Cape' },
            { key: '3', value: 'Free State' },
            { key: '4', value: 'Gauteng' },
            { key: '5', value: 'KwaZulu-Natal' },
            { key: '6', value: 'Limpopo' },
            { key: '7', value: 'Mpumalanga' },
            { key: '8', value: 'Northern Cape' },
            { key: '9', value: 'North West' },
            { key: '10', value: 'Western Cape' }
        ];
        fields.push(provinceField);

        let suburbField = new TextboxControl();
        suburbField.key = 'suburb';
        suburbField.label = 'Suburb';
        suburbField.placeHolder = 'Enter suburb'
        suburbField.order = 7;
        suburbField.preventKeys = '\\w';
        fields.push(suburbField);

        let postalCodeField = new TextboxControl();
        postalCodeField.key = 'postalCode';
        postalCodeField.label = 'Postal Code';
        postalCodeField.placeHolder = 'Enter postal code';
        postalCodeField.validNumberOnly;
        postalCodeField.order = 8;
        postalCodeField.preventKeys = '\\d';
        fields.push(postalCodeField);

        let countryField = new DropdownControl();
        countryField.key = 'country';
        countryField.label = 'Country';
        countryField.order = 9;
        countryField.options = this.addressService.getCountries();
        fields.push(countryField);

        let mobileNumberField = new TextboxControl();
        mobileNumberField.key = 'mobileNumber';
        mobileNumberField.label = 'Mobile Number';
        mobileNumberField.placeHolder = 'Enter mobile number';
        mobileNumberField.order = 10;
        mobileNumberField.validNumberOnly = true;
        mobileNumberField.required = true;
        mobileNumberField.preventKeys = '\\d';
        fields.push(mobileNumberField);

        let emailField = new TextboxControl();
        emailField.key = 'email';
        emailField.label = 'Email';
        emailField.placeHolder = 'Enter email address'
        emailField.order = 11;
        emailField.validEmail = true;
        fields.push(emailField);

        let dateOfBirthField = new DatepickerControl();
        dateOfBirthField.key = 'dateOfBirth';
        dateOfBirthField.label = 'Date of Birth';
        dateOfBirthField.order = 12;
        fields.push(dateOfBirthField);

        let anniversaryField = new DatepickerControl();
        anniversaryField.key = 'anniversary';
        anniversaryField.label = 'Anniversary';
        anniversaryField.order = 13;
        fields.push(anniversaryField);

        let enrollmentDateField = new DatepickerControl();
        enrollmentDateField.key = 'enrollmentDate';
        enrollmentDateField.label = 'Enrollment Date';
        enrollmentDateField.order = 12;
    
       
        fields.push(enrollmentDateField);

        let externalIdField = new TextboxControl();
        externalIdField.key = 'externalId';
        externalIdField.label = 'Membership Number';
        externalIdField.placeHolder = 'Enter membership number';
        externalIdField.order = 14;
        externalIdField.preventKeys = '\\d';
        fields.push(externalIdField);

        let emailMarketingField = new CheckboxControl();
        emailMarketingField.key = 'receiveEmail';
        emailMarketingField.label = 'Accept Email Marketing';
        emailMarketingField.order = 17;
        fields.push(emailMarketingField);

        let smsMarketingField = new CheckboxControl();
        smsMarketingField.key = 'receiveSms';
        smsMarketingField.label = 'Accept SMS Marketing';
        smsMarketingField.order = 18;
        fields.push(smsMarketingField);

        let statusField = new CheckboxControl();
        statusField.key = 'statusId';
        statusField.label = 'Disabled';
        statusField.order = 19;
        fields.push(statusField); 

        return fields.sort((a, b) => a.order - b.order);
    }

    public getLoyaltyPointsFields(): Array<FormControlBase<any>> {
        let loyaltypointsfields = new Array<FormControlBase<any>>();
        let unitCountField = new TextboxControl();
        unitCountField.key = 'unitCount';
        unitCountField.label = 'Point Count';
        unitCountField.order = 1;
        unitCountField.type = 'number';
        unitCountField.validNumberOnly = true;
        unitCountField.warning = 'Reward count will be recalculated based on the point count submitted.';
        loyaltypointsfields.push(unitCountField);

        let rewardCountField = new TextboxControl();
        rewardCountField.key = 'rewardCount';
        rewardCountField.label = 'Reward Count';
        rewardCountField.order = 2;
        rewardCountField.type = 'number';
        loyaltypointsfields.push(rewardCountField);

        let changeReasonsField = new DropdownControl();
        changeReasonsField.key = 'changeReasonItem';
        changeReasonsField.label = 'Change Reason';
        changeReasonsField.order = 3;
        changeReasonsField.options = [
            { key: 'Balance Correction', value: 'Balance Correction' },
            { key: 'Gift', value: 'Gift' },
            { key: 'Donation', value: 'Donation' },
            { key: 'Prize', value: 'Prize' },
            { key: 'Refund', value: 'Refund' },
            { key: 'Complaint', value: 'Complaint' },
            { key: 'Loyalty Balance Reinstatement', value: 'Loyalty Balance Reinstatement' },
            { key: 'Customer Flagged', value: 'Customer Flagged' },
            { key: 'Other', value: 'Other' }
        ];
        loyaltypointsfields.push(changeReasonsField);

        let changeReason = new TextareaControl();
        changeReason.key = 'changeReason';
        changeReason.label = 'Additional notes';
        changeReason.order = 4;
        loyaltypointsfields.push(changeReason);

        let sendRedemptionPinPrompt = new CheckboxControl();
        sendRedemptionPinPrompt.key = 'sendRedemptionPinPrompt';
        sendRedemptionPinPrompt.label = 'Send Redemption Pin?';
        sendRedemptionPinPrompt.order = 5;
        loyaltypointsfields.push(sendRedemptionPinPrompt);
        
        return loyaltypointsfields.sort((a, b) => a.order - b.order);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/customer/customer-management-field.service.ts